import { DispatchType } from '../../../@types/redux-types'
import { hideMessage, showMessage } from '../../reducers/message/messageFeature'

export const doShowMessage = (message: string) => (dispatch: DispatchType) =>
  dispatch(showMessage({ message: message }))

export const doHideMessage = () => (dispatch: DispatchType) => dispatch(hideMessage())
